import {
    Box,
    Divider,
    Stack,
    Typography,
    Button,
} from '@mui/material'
import { Image } from 'antd'
import FooterBannerImage from '../../assets/footer-banner.webp'
import FooterPhone from '../../assets/app/home/home_phone.png'
import FooterLocation from '../../assets/app/home/home_location.png'
import FooterTime from '../../assets/app/home/home_date.png'
import MerchantLogin from '../../assets/new-footer/footer_merchant_login.png'
import CustomerLogin from '../../assets/new-footer/footer_customer_login.png'
import AppGallery from '../../assets/download/download_appgallery.png'
import AppStore from '../../assets/download/download_appstore.png'
import GooglePlay from '../../assets/download/download_googleplay.png'
import ShareInstagram from '../../assets/new-footer/share_instagram.png'
import ShareFaceBook from '../../assets/new-footer/share_facebook.png'
import ShareYoutune from '../../assets/new-footer/share_youtube.png'
import Logo from '../../assets/download/logo_icon.png'
import { PORTOAL_LOGIN_LINK, ROOT_PATH, MERCHANT_LOGIN_LINK, FACEBOOK_LINK, YOUTUBE_LINK, INSTAGRAM_LINK, GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../common/config'
import { useTranslation } from 'react-i18next'

export const NewAppFooter: React.FC = () => {
    const { t } = useTranslation()

    // 打开product
    const openProduct = () => {
        window.open(ROOT_PATH + '/product')
    }
    // 打开faq
    const openFaq = () => {
        window.open(ROOT_PATH + '/faq')
    }
    // 打开how to pay
    const openHowToPay = () => {
        window.open(ROOT_PATH + '/repayment-channel')
    }

    // 打开contact us
    const openContactUs = () => {
        window.open(ROOT_PATH + '/contact-us')
    }

    // merchat login
    const clickMerchantLogin = () => {
        window.open(MERCHANT_LOGIN_LINK)
    }

    // Portal login
    const clickPortalLogin = () => {
        window.open(PORTOAL_LOGIN_LINK)
    }

    // 打开privacy
    const openPrivacyPolicy = () => {
        window.open(ROOT_PATH + '/privacy')
    }

    // 打开terms&conditions
    const openTermsAndConditions = () => {
        window.open(ROOT_PATH + '/terms-conditions')
    }

    // 打开facebook
    const clickFacebook = () => {
        window.open(FACEBOOK_LINK)
    }

    // 打开youbube
    const clickYoutube = () => {
        window.open(YOUTUBE_LINK)
    }

    // 打开ins
    const clickIns = () => {
        window.open(INSTAGRAM_LINK)
    }

    // ======================= GooglePlay
    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= RENDER FUNCTIONS

    const renderCopyrightSection = () => (
        <Box sx={{
            paddingTop: '40px',
        }}>
            <Stack
                direction={'column'}
                justifyContent="space-between"
                alignItems={'center'}
            >
                <Typography fontSize={16} fontWeight={400} color="#6B6B6B" textAlign="center">
                    {t('t93')}
                </Typography>
                <Stack direction="row" spacing={2} alignSelf="center" alignItems={'center'} paddingTop={'24px'}>
                <Button 
                    onClick={openPrivacyPolicy}
                    sx={{
                        //width: '100px',
                        textDecoration: 'none',
                        cursor: 'pointer',
                        textTransform: 'none',
                        padding: '0px',
                        alignContent: 'start',
                        justifyContent: 'start',
                        alignItems: 'center',
                        '&:hover': {
                            bgcolor: '#FFFDF7',
                        },
                    }} >
                        <Typography
                            fontSize={16} fontWeight={700}
                            color={'#6B6B6B'}
                        >
                            {t('t94')}
                        </Typography>
                    </Button>
                    <Button 
                        onClick={openTermsAndConditions}
                        sx={{
                            //width: '100px',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            textTransform: 'none',
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }} >
                        <Typography
                            fontSize={16} fontWeight={700}
                            color={'#6B6B6B'}
                        >
                            {t('t95')}
                        </Typography>
                    </Button>
                </Stack>

                <Stack direction={'row'} justifyContent={'space-between'} paddingTop={'30px'} spacing={2}>
                    <Stack>
                        <Box sx={{
                            cursor: 'pointer',
                        }}
                            onClick={() => clickFacebook()}
                        >
                            <Image src={ShareFaceBook} preview={false} width={32} height={32} alt=''></Image>
                        </Box>
                    </Stack>

                    <Stack>
                        <Box sx={{
                            cursor: 'pointer',
                        }}
                            onClick={() => clickYoutube()}>
                            <Image src={ShareYoutune} preview={false} width={32} height={32} alt=''></Image>
                        </Box>
                    </Stack>

                    <Stack>
                        <Box sx={{
                            cursor: 'pointer',
                        }}
                            onClick={() => clickIns()}>
                            <Image src={ShareInstagram} preview={false} width={32} height={32} alt=''></Image>
                        </Box>
                    </Stack>
                </Stack>
            </Stack>
        </Box>
    )

    // ======================= VIEWS
    return (
        <Stack>
            <Box
                component="footer"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundImage: `url(${FooterBannerImage})`,
                    backgroundBlendMode: 'overlay',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    paddingTop: '40px',
                    paddingBottom: '40px',
                    backgroundColor: '#FFFDF7'
                }}
            >

                <Box
                    sx={{
                        width: '100%',
                        backgroundColor: '#FFFDF7',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'start'
                    }}
                >
                    {/* SHENMA Credit Sdn Bhd */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                            SHENMA Credit Sdn Bhd
                        </Typography>
                        <Typography fontSize={16} fontWeight={400} color={'#141F39'}>
                            (201401009329 / 1085407-K)
                        </Typography>
     
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'top',
                            paddingTop: '24px',
                        }}>
                            <Image src={FooterLocation} width={22} height={29} alt='' preview={false}></Image>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'top',
                                flex: '1'
                            }}>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    2, Jalan Muthu Palaniappan, 14000 Bukit Mertajam, Penang
                                </Typography>
                            </Box>
                        </Box>
                       
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            paddingTop: '12px',
                        }}>
                            <Image src={FooterPhone} width={24} height={24} alt='' preview={false}></Image>
                            <Box sx={{
                                flex: '1'
                            }}>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    04-5230033
                                </Typography>
                            </Box>
                        </Box>
           
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'top',
                            paddingTop: '12px',
                        }}>
                            <Image src={FooterTime} width={24} height={24} alt='' preview={false}></Image>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'top',
                                flex: '1'
                            }}>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t81')}
                                </Typography>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t82')}
                                </Typography>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t83')}
                                </Typography>
                            </Box>
                        </Box>
             
                    </Box>

                    {/* Products & Services */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: '30px',
                    }}>
                        <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                            {t('t84')}
                        </Typography>
                        <Button onClick={openProduct}
                            sx={{
                                width: '100%',
                                marginTop: '24px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'center',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t84')}
                            </Typography>
                        </Button>


                        <Button onClick={openFaq}
                            sx={{
                                width: '100%',
                                marginTop: '12px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'center',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t85')}
                            </Typography>
                        </Button>

                        <Button onClick={openHowToPay}
                            sx={{
                                width: '100%',
                                marginTop: '12px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'center',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t86')}
                            </Typography>
                        </Button>

                        <Button onClick={openContactUs}
                            sx={{
                                width: '100%',
                                marginTop: '12px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'center',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t87')}
                            </Typography>
                          
                        </Button>

                    </Box>

                    {/* Online Service */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '0px',
                        paddingTop: '30px',
                    }}>
                        <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                            {t('t88')}
                        </Typography>

                        <Button onClick={clickMerchantLogin} sx={{
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            textTransform: 'none',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingTop: '24px',
                            }}>
                                <Image src={MerchantLogin} width={24} height={24} alt=''></Image>
                                <Box sx={{
                                    flex: '1'
                                }}>
                                    <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                        {t('t89')}
                                    </Typography>
                                </Box>
                            </Box>
                        </Button>


                        <Button onClick={clickPortalLogin} sx={{
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            textTransform: 'none',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingTop: '12px',
                            }}>
                                <Image src={CustomerLogin} width={24} height={24} alt=''></Image>
                                <Box sx={{
                                    flex: '1'
                                }}>
                                    <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                        {t('t90')}
                                    </Typography>
                                </Box>
                            </Box>
                        </Button>

                    </Box>
                </Box>

                {/* SHENMA Mobile */}
                <Box sx={{
                    backgroundColor: '#FFFDF7',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    paddingTop: '40px',
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                        <Image src={Logo} width={50} height={50} alt='' preview={false}></Image>
                        <Box sx={{
                            display: 'flex',                        
                            paddingLeft: '8px',
                            flex: '1'
                        }}>
                            <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                                {t('t91')}<br />
                                {t('t92')}
                            </Typography>
                        </Box>
                       
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: '20px',
                        paddingBottom: '40px',
                        justifyContent: 'start',
                        alignContent: 'start',
                        alignItems: 'start',
                    }}>
                        <Box onClick={clickGooglePlay} sx={{
                            cursor: 'pointer',
                        }}>
                            <Image src={GooglePlay} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                        <Box onClick={clickAppStore} sx={{
                            cursor: 'pointer',
                        }}>
                            <Image src={AppStore} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                        <Box onClick={clickAppGallery} sx={{
                            cursor: 'pointer',
                        }}>
                            <Image src={AppGallery} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                    </Box>
                </Box>

                <Box>
                    <Divider sx={{ background: 'rgba(57, 33, 245, 0.15)' }} />
                </Box>
                {renderCopyrightSection()}
            </Box>
        </Stack>
    )
}

// ======================= EXPORT
export default NewAppFooter
